import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './DashboardApprovalPanel.css';

function pickAuthToken(u) {
  if (!u || typeof u !== 'object') return '';
  return String(
    u.token || u.session_token || u.sessionToken || u.access_token || u.accessToken || '',
  ).trim();
}

/**
 * 대시보드: 사내교육 미이수자 목록 (이름·부서·과정)
 * 메뉴 권한: dashboard-training-incomplete
 */
export default function DashboardTrainingIncompletePanel({ refreshToken = 0 }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setErr('');
    try {
      const token = pickAuthToken(user);
      const headers = {};
      if (token) {
        headers.Authorization = `Bearer ${token}`;
        headers['X-MRT-Token'] = token;
      }
      const res = await fetch('/api/erp_internal_training/incomplete-learners', {
        method: 'GET',
        headers,
        credentials: 'include',
      });
      if (!res.ok) {
        throw new Error(`http_${res.status}`);
      }
      const data = await res.json().catch(() => null);
      setItems(Array.isArray(data?.items) ? data.items : []);
    } catch (e) {
      setItems([]);
      setErr(String(e?.message || e || '불러오기 실패'));
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    load();
  }, [load, refreshToken]);

  return (
    <section className="dap-panel dti-panel" aria-label="미이수 교육자">
      <div className="dap-panel__head">
        <h3 className="dap-panel__title">미이수 교육자</h3>
        <button type="button" className="dap-panel__refresh" onClick={load} disabled={loading}>
          {loading ? '…' : '새로고침'}
        </button>
      </div>
      <p className="dap-panel__sub">
        기간이 시작된 사내교육 중 아직 수료하지 않은 대상입니다.
      </p>
      {err ? <div className="dap-panel__err">{err}</div> : null}
      {loading && items.length === 0 ? (
        <div className="dap-panel__muted">불러오는 중…</div>
      ) : null}
      {!loading && items.length === 0 && !err ? (
        <div className="dap-panel__empty">현재 미이수 교육자가 없습니다.</div>
      ) : null}
      {items.length > 0 ? (
        <ul className="dap-list dti-list">
          {items.map((row) => (
            <li key={`${row.course_seq}-${row.email}`} className="dap-item dti-item">
              <div className="dti-item__name">
                {row.name || row.email}
                {row.overdue ? <span className="dti-badge">기한초과</span> : null}
              </div>
              <div className="dti-item__meta">
                <span>{row.dept_name || '부서없음'}</span>
                <span>{row.course_title || '교육'}</span>
                <span>
                  {row.due_date_end ? `마감 ${row.due_date_end}` : '마감 미정'}
                  {' · '}
                  {Math.round(row.progress_percent || 0)}%
                </span>
              </div>
            </li>
          ))}
        </ul>
      ) : null}
      <button
        type="button"
        className="dti-go"
        onClick={() => navigate('/erp?menu=internal_training')}
      >
        사내교육 이수 화면
      </button>
    </section>
  );
}
